import React from 'react';

import ComingSoon from '../../utils/Construction';

export const NaiveBayesSum = () => {
  return(
    <div>
      <ComingSoon />
    </div>
  )
}